import { lazy } from "react";
import lazyLoad from "routers/utils/lazyLoad";
import LayoutIndex from "layout/mainLayout";

const commonRouter = [
  {
    element: <LayoutIndex />,
    children: [
      {
        path: "/",
        element: lazyLoad(lazy(() => import("view/login"))),
      },
      {
        path: "/singup",
        element: lazyLoad(lazy(() => import("view/singup"))),
      },
      // {
      //   path: "/home",
      //   element: lazyLoad(lazy(() => import("view/main"))),
      // },
    ]
  },
];

export default commonRouter;
